export const formatOgImage = (imageURL: string) => {
  if (!imageURL) return '';
  const cdnUrl = imageURL.replace(/www\./, 'cdn.');
  try {
    const urlObj = new URL(cdnUrl);
    return `${urlObj.origin}/cdn-cgi/image/width=1200,height=800,fit=crop${urlObj.pathname}`;
  } catch {
    return `/cdn-cgi/image/width=1200,height=800,fit=crop${cdnUrl.startsWith('/') ? '' : '/'}${cdnUrl}`;
  }
};
